import { c as _c } from "react/compiler-runtime";
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoRefresh16 } from '@onefootprint/icons';
import { Dropdown, useConfirmationDialog, useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { runWorkflow } from '@/features/onboarding-trace';
import useSession from '@/hooks/use-session';
type AdvanceStuckIncodeProps = {
  workflowId: string;
  onClick: () => void;
};
const AdvanceStuckIncode = t0 => {
  const $ = _c(21);
  const {
    workflowId,
    onClick
  } = t0;
  const {
    toast
  } = useToast();
  const showErrorToast = useRequestErrorToast();
  const confirm = useConfirmationDialog();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "advanceStuckIncode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    authHeaders
  } = useSession();
  let t2;
  if ($[1] !== authHeaders || $[2] !== workflowId) {
    t2 = () => runWorkflow(authHeaders, {
      id: workflowId,
      advanceStuckIncodeSession: true
    });
    $[1] = authHeaders;
    $[2] = workflowId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t || $[5] !== toast) {
    t3 = () => {
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
    };
    $[4] = t;
    $[5] = toast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showErrorToast || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: showErrorToast
    };
    $[7] = showErrorToast;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const mutation = useMutation(t4);
  let t5;
  if ($[11] !== confirm || $[12] !== mutation || $[13] !== onClick || $[14] !== t) {
    t5 = () => {
      onClick();
      confirm.open({
        title: t(_temp3),
        description: t(_temp4),
        primaryButton: {
          label: t(_temp5),
          onClick: () => mutation.mutate(undefined)
        },
        secondaryButton: {
          label: t(_temp6)
        }
      });
    };
    $[11] = confirm;
    $[12] = mutation;
    $[13] = onClick;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const handleClick = t5;
  let t6;
  if ($[16] !== t) {
    t6 = t(_temp7);
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== handleClick || $[19] !== t6) {
    t7 = <Dropdown.Item iconLeft={IcoRefresh16} onSelect={handleClick}>{t6}</Dropdown.Item>;
    $[18] = handleClick;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default AdvanceStuckIncode;
function _temp($) {
  return $.toast.title;
}
function _temp2($_0) {
  return $_0.toast.description;
}
function _temp3($_1) {
  return $_1.confirm.title;
}
function _temp4($_2) {
  return $_2.confirm.description;
}
function _temp5($_3) {
  return $_3.confirm.cta;
}
function _temp6($_4) {
  return $_4.confirm.cancel;
}
function _temp7($_5) {
  return $_5.label;
}